export default "__VITE_ASSET__YKTXUEF2__"